import React from "react";
import styles from "./modal.module.css";
import successimg from "../../assets/done.gif";

export const Modalsuccess = ({ success }) => {
  return (
    <div
      className={`modal show fade modal-dialog-centered ${
        success ? styles.disBlock : styles.disNone
      }`}
      id="staticBackdrop"
      // data-bs-backdrop="static"
      // data-bs-keyboard="true"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <img src={successimg} alt="my-gif" />

            <span className="mx-4 ">Issued to Dhiway Wallet</span>
          </div>
        </div>
      </div>
    </div>
  );
};
